import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { MfaType } from '../../../generic-components/MFA/types';

interface IProps {
    customerId: string;
    mfaType: MfaType;
}

export const useResendMfaCode = () => useMutation(
  'useResendMfaCode',
  async ({ customerId, mfaType }: IProps) => {
    const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/authorized/user/sendOtp`, {
      mfaType,
    });
    return res.data;
  },
);
